import Link from 'next/link'
import { Twitter, Instagram, Linkedin } from 'lucide-react'

export function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 mt-16 sm:mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8 mb-12">
          {/* Product */}
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-4">
              Product
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/help"
                  className="text-sm md:text-base text-text-secondary hover:text-text-primary transition-colors"
                >
                  Help
                </Link>
              </li>
              <li>
                <Link
                  href="/news"
                  className="text-sm md:text-base text-text-secondary hover:text-text-primary transition-colors"
                >
                  News
                </Link>
              </li>
              <li>
                <Link
                  href="/pricing"
                  className="text-sm md:text-base text-text-secondary hover:text-text-primary transition-colors"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  href="/experts"
                  className="text-sm md:text-base text-text-secondary hover:text-text-primary transition-colors"
                >
                  Experts
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-4">
              Resources
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/guides"
                  className="text-sm md:text-base text-text-secondary hover:text-text-primary transition-colors"
                >
                  Guides
                </Link>
              </li>
              <li>
                <Link
                  href="/newsletter"
                  className="text-sm md:text-base text-text-secondary hover:text-text-primary transition-colors"
                >
                  Newsletter
                </Link>
              </li>
              <li>
                <Link
                  href="/experts/apply"
                  className="text-sm md:text-base text-text-secondary hover:text-text-primary transition-colors"
                >
                  Become Expert
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-4">
              Company
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/about"
                  className="text-sm md:text-base text-text-secondary hover:text-text-primary transition-colors"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  href="/privacy"
                  className="text-sm md:text-base text-text-secondary hover:text-text-primary transition-colors"
                >
                  Privacy
                </Link>
              </li>
              <li>
                <Link
                  href="/terms"
                  className="text-sm md:text-base text-text-secondary hover:text-text-primary transition-colors"
                >
                  Terms
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-4">
              Connect
            </h3>
            <div className="flex gap-4">
              <Link
                href="https://twitter.com/TheNormalAI"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center text-text-secondary hover:text-indigo transition-colors"
                aria-label="Twitter"
              >
                <Twitter size={20} />
              </Link>
              <Link
                href="https://instagram.com/thenormal.ai"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center text-text-secondary hover:text-indigo transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </Link>
              <Link
                href="https://linkedin.com/company/thenormal-ai"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center text-text-secondary hover:text-indigo transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-200 pt-8">
          <p className="text-sm text-text-secondary">
            © 2026 thenormal.ai · AI for Normies
          </p>
        </div>
      </div>
    </footer>
  )
}
